import { useTranslation } from 'react-i18next';

import { WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { usePathSet } from '@/hooks/usePathSet';

// eslint-disable-next-line sonarjs/no-duplicate-string
export const ScenarioDetails = ({ activeTab = 'physical-risk' }: { activeTab?: string }) => {
  const { t } = useTranslation();
  const pathSet = usePathSet();

  const defaultConfiguration = {
    name: 'scenario_details',
    type: WidgetType.a_stack,
    widgets: [
      {
        name: 'scenario_details_tabs',
        type: WidgetType.m_tabs,
        visible: true,
        relatedData: {
          styles: {
            root: 'justify-start items-start',
            tabsList: 'grid grid-cols-3 w-full justify-start items-start',
            tabTrigger: 'justify-start items-start w-fit',
            content: 'w-full',
          },
          tabs: [
            {
              default: activeTab === 'methodology',
              label: t('shared.scenarioAnalysis.tabs.methodology.label'),
              description: t('shared.scenarioAnalysis.tabs.methodology.description'),
              path: pathSet.scenarioModelsMethodology,
              routeSlug: 'methodology',
              styles: {
                tab: 'bg-neutral-black-4',
              },
              content: (
                <WidgetSlotRenderer
                  nestedWidget={{
                    name: 'scenario_methodology_content',
                    type: WidgetType.o_c_methodology_tab,
                    visible: true,
                    relatedData: {},
                  }}
                />
              ),
            },
            {
              default: activeTab === 'physical-risk',
              label: t('shared.scenarioAnalysis.tabs.physicalRisk.label'),
              description: t('shared.scenarioAnalysis.tabs.physicalRisk.description'),
              path: pathSet.scenarioModelsPhysicalRisk,
              routeSlug: 'physical-risk',
              content: (
                <WidgetSlotRenderer
                  nestedWidget={{
                    name: 'scenario_physical_risk_content',
                    type: WidgetType.o_c_physical_risk_tab,
                    visible: true,
                    relatedData: {},
                  }}
                />
              ),
            },
            {
              default: activeTab === 'financial-impact',
              label: t('shared.scenarioAnalysis.tabs.financialImpact.label'),
              description: t('shared.scenarioAnalysis.tabs.financialImpact.description'),
              path: pathSet.scenarioModelsFinancialImpact,
              routeSlug: 'financial-impact',
              content: (
                <WidgetSlotRenderer
                  nestedWidget={{
                    name: 'scenario_financial_impact_content',
                    type: WidgetType.o_c_financial_impact_tab,
                    visible: true,
                    relatedData: {},
                  }}
                />
              ),
            },
          ],
        },
      },
    ],
  };

  return <WidgetSlotRenderer nestedWidget={defaultConfiguration} />;
};
